export default "__VITE_ASSET__C1k_6bHQ__";